/** Education tiles — same facts as the original list. */
export const EDUCATION_TILES = [
  {
    id: 'hku',
    title: 'HKU',
    metaLine: 'BSc(Hons) · 2004',
    teaser: 'The University of Hong Kong — undergraduate studies.',
    items: ['Bachelor of Science with Honours (2004).'],
  },
  {
    id: 'hkbu',
    title: 'HKBU',
    metaLine: 'MA · 2009',
    teaser: 'Hong Kong Baptist University — postgraduate studies.',
    items: ['Master of Arts (2009).'],
  },
];
